import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { PreloginService } from './services/prelogin.service';

@Injectable()
export class MyInterceptor implements HttpInterceptor {

    constructor(private router: Router, private preLoginService: PreloginService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // Uncomment if you want to see.
                    // console.log('event--->>>', event);
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                // Session Expired
                if (error.status == 403 && error.statusText == 'Forbidden' && error.error.message == 'session expired') {
                    localStorage.clear();
                    this.preLoginService.setLoggedInFlagForNav(false);
                    this.router.navigate(['/login'], { queryParams: { err: 403 } });
                }
                // Backend server down
                if (error.status == 0 && error.ok == false && error.statusText == 'Unknown Error') {
                    localStorage.clear();
                    this.preLoginService.setLoggedInFlagForNav(false);
                    this.router.navigate(['/login'], { queryParams: { err: 0 } });
                }
                return throwError(error);
            })
        );
    }
}